import { useEffect, useRef, useState } from "react";

/*
ヒントを 1 つずつ開く振る舞いだけを持つ。見た目は持たない。

前は「ヒント 1」〜「ヒント 5」が同じ見た目のアコーディオンで並び、どれが軽い手がかりで
どれが答えに近いかが分からなかった。全部を一度に開けるので、考える前に最後の
(答えに近い) ヒントを読めてしまう。

釦は 1 つだけ置き、押すたびに次の 1 つを下に積む。開いたものは閉じない。
一度見たものは見なかったことにできないので、閉じる操作は持たせない。
見た目 (どの段を黄にするか) は HintLadder が持つ
*/
export function useHintSteps(
  hints: string[],
  onOpenedCountChange?: (count: number) => void,
) {
  const [openedCount, setOpenedCount] = useState(0);

  // 別の問題に移ったら数え直す。同じ位置のセクションは React に使い回されるので、
  // これが無いと前の問題で開いた数が次の問題に持ち越され、最初から読めてしまう
  const hintsKey = hints.join("\u0000");
  const prevKeyRef = useRef(hintsKey);
  useEffect(() => {
    if (prevKeyRef.current !== hintsKey) {
      prevKeyRef.current = hintsKey;
      setOpenedCount(0);
      onOpenedCountChange?.(0);
    }
  }, [hintsKey, onOpenedCountChange]);

  const lastItemRef = useRef<HTMLLIElement>(null);
  const focusLastRef = useRef(false);
  useEffect(() => {
    if (focusLastRef.current && openedCount === hints.length) {
      focusLastRef.current = false;
      lastItemRef.current?.focus();
    }
  }, [openedCount, hints.length]);

  const total = hints.length;
  // 前の問題の数が残ったまま描かれる 1 回の間も、今の問題の数を超えて出さない
  const opened =
    prevKeyRef.current === hintsKey ? Math.min(openedCount, total) : 0;

  const openNext = () => {
    if (opened >= total) return;
    const next = opened + 1;
    // 最後を開くと釦が消えて focus の行き先が無くなる。開いた最後のヒントへ移す
    focusLastRef.current = next === total;
    setOpenedCount(next);
    onOpenedCountChange?.(next);
  };

  return { total, opened, openNext, lastItemRef };
}
